export const areThreadIdsLooselyEqual = (threadIdA, threadIdB) => {
  try {
    return Boolean(threadIdA && threadIdB && parseInt(threadIdA, 10) === parseInt(threadIdB, 10));
  } catch (e) {
    return false;
  }
};